<template>
    <div class="tw-rounded tw-text-left tw-bg-white tw-shadow-xl tw-min-h-96 tw-flex tw-overflow-hidden" style="height:75vh !important;">
        <div class="tw-w-24 lg:tw-w-1/4 tw-max-w-136 tw-border-r border-default tw-border-gray-200 tw-divide-y tw-divide-gray-100 tw-overflow-auto">

            <div v-if="states.loading_chats" class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                <div>{{$text.loading}}</div>
            </div>
            <template v-else>

                <input v-model="states.search" type="text" class="tw-hidden lg:tw-block tw-h-16 tw-py-0 tw-outline-none border-default tw-px-6 tw-w-full tw-rounded-none" :placeholder="$text.search_chats">
                <div v-if="sortedChats.length === 0" class="tw-p-6 tw-text-center border-default">{{$text.no_chats_found}}</div>
                <list-item
                    v-for="chat in sortedChats" :isActive="chat.id === _.get(states.activeChat,'id')"
                    :user="user" :chat="chat" :key="chat.id" v-on:click.native="() => store.selectChat(chat)"
                />

            </template>

        </div>

        <div v-if="states.activeChat === null" class="tw-w-2/3 tw-flex tw-items-center tw-justify-center">
            <div class="tw-text-gray-600 text-text-6xl">{{$word.select_a_chat}}</div>
        </div>

        <conversation v-else/>

    </div>
</template>
<script>
    import ListItem from './messenger-list-item'
    import Conversation from './messenger-conversation'
    import store from './messenger-store'

    export default {
        components: {
            ListItem,
            Conversation,
        },
        props: {
            user: {}
        },
        created() {
            this.store = store
            this.states = store.states
            store.states.user = this.user
            store.init(this.user)
            // store.getChats().then(() => {
            //     store.joinUserChannel()
            // })
            // store.registerTypingIntervals()
        },
        computed: {
            sortedChats() {
                return _.chain(this.states.chats)
                    .filter(chat => store.chat_title(chat).toLowerCase().includes(store.states.search.toLowerCase()))
                    .values()
                    .orderBy([chat => store.isBlocked(store.other_user(chat)), 'updated_at'], ['asc', 'desc'])
                    .value()
            }
        },
    }
</script>
